import { render, staticRenderFns } from "./ReportBadge.vue?vue&type=template&id=8125e72c&scoped=true"
import script from "./ReportBadge.vue?vue&type=script&lang=js"
export * from "./ReportBadge.vue?vue&type=script&lang=js"
import style0 from "./ReportBadge.vue?vue&type=style&index=0&id=8125e72c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8125e72c",
  null
  
)

export default component.exports